import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AppTitleService {
  titles: string[] = [];
  private _isInvisible: boolean = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.buildTitle(this.activatedRoute.root.firstChild, event.url);
      }
    });
  }

  private buildTitle(route: ActivatedRoute, url: string) {

    while (route.firstChild) {
      route = route.firstChild;
    }

    const titles = route.routeConfig && route.routeConfig.data && route.routeConfig.data['title'] ? route.routeConfig.data['title'] : [];
    this.titles.splice(0, this.titles.length);
    Array.prototype.push.apply(this.titles, titles || []);

    this._isInvisible = route.routeConfig && route.routeConfig.data && route.routeConfig.data['isInvisible'] ? route.routeConfig.data['isInvisible'] : false;

  }

  get isInvisible() {
    return this._isInvisible;
  }
}
